import Table from "@/app/charts/Table";
import InfoTooltip from "@/app/components/InfoTooltip";

export function ChartTitle({ title, tooltip, as: Heading = "h2" }) {
  return (
    <>
      <Heading className="flex items-center gap-2 text-2xl font-bold text-blue-700">
        <span>{title}</span>
        {tooltip && (
          <InfoTooltip
            content={tooltip}
            label={title}
            className="text-blue-700"
          />
        )}
      </Heading>
      <hr className="my-4 w-1/6 border-b border-gray-300" />
    </>
  );
}

export default function ChartSection({
  title,
  Chart,
  table,
  tooltip,
  titleAs = "h2",
}) {
  return (
    <div className="mt-5 p-5 shadow-lg">
      <ChartTitle title={title} tooltip={tooltip} as={titleAs} />
      <div className="flex flex-col-reverse items-center justify-center gap-5 md:flex-row">
        <div className="h-80 w-full overflow-auto md:w-1/3">
          <Table columnNames={Object.values(table[0])} rowValues={table[1]} />
        </div>
        <div className="w-full md:w-2/3">{Chart}</div>
      </div>
    </div>
  );
}
